import { useState } from "react";
import { type ButtonProps as MuiButtonProps } from "@mui/material/Button";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import BaseButton from "../BaseButton";

type ButtonCustomColorVariant = "warning" | "error";

export interface TooltipButtonProps extends MuiButtonProps {
  loading?: boolean;
  customColorVariant?: ButtonCustomColorVariant;
  tooltip: string;
  tooltipPlacement?: TooltipProps["placement"];
}

export const TooltipButton = ({
  tooltip,
  tooltipPlacement = "top",
  ...buttonProps
}: TooltipButtonProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  return (
    <Tooltip open={isTooltipOpen} placement={tooltipPlacement} title={tooltip}>
      <Box
        onMouseEnter={() => setIsTooltipOpen(true)}
        onMouseLeave={() => setIsTooltipOpen(false)}>
        <BaseButton {...buttonProps} />
      </Box>
    </Tooltip>
  );
};

export default TooltipButton;
